import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  IconButton,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useContext, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { APP_ICONS } from "../../../assets";
import AuthContainer from "../../../components/containers/AuthContainer";
import AppContext from "../../../components/context/appContext";
import CustomSnackbar from "../../../components/customSnackBar/customSnackBar";
import AppLoader from "../../../components/loader/loader";
import { loginUser } from "../../../services/authFn";
import { setUser } from "../../../redux/slices/userSlice";
import { useDispatch } from "react-redux";

const LoginPage = () => {
  const snackRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { login } = useContext(AppContext);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValues, setInputValues] = useState({
    username: "",
    password: "",
  });
  const handleOpenSnack = (status, message) => {
    snackRef.current.isOpenSnack({
      snackType: status,
      snackMessage: message,
    });
  };
  const handleLogin = async () => {
    const { username, password } = inputValues;

    if (!username) return handleOpenSnack("error", "username is required");

    if (!password) return handleOpenSnack("error", "Password is required");

    try {
      const payload = { username, password };
      setIsLoading(true);
      const response = await loginUser(payload);
      let data = response.data.data;
      if (response.status == 200 || response.status == 201) {
        dispatch(setUser(data?.userDetails));
        localStorage.setItem("user-data", JSON.stringify(data?.userDetails));
        localStorage.setItem("token", JSON.stringify(data?.token));
      }
      if (response.data.status === "success") {
        const newUserObj = {
          id: data.userDetails._id,
          ...data.userDetails,
          token: data.token,
        };

        login(newUserObj);

        snackRef.current.isOpenSnack({
          snackType: "success",
          snackMessage: response.data.message,
        });

        navigate("/");
      } else {
        snackRef.current.isOpenSnack({
          snackType: "error",
          snackMessage: response?.data.message,
        });
      }
    } catch (error) {
      snackRef.current.isOpenSnack({
        snackType: "error",
        snackMessage: error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthContainer>
      <AppLoader isVisible={isLoading} />
      {/* <Stack alignItems={"center"}>
        <img src={APP_LOGO.appLogo} width={177} />
      </Stack> */}
      {/* <AppLoader isVisible={isLoading} /> */}
      <Typography
        color={"primary.main"}
        fontSize={"2rem"}
        fontWeight={700}
        letterSpacing={1.5}
        textShadow="1px 1px 2px rgba(0, 0, 0, 0.5)"
        sx={{
          // backgroundColor: "primary.main",
          // padding: "5px 10px",
          borderRadius: "12px",
          display: "block",
          textAlign: "center",
        }}
      >
        Residental Jobs
      </Typography>
      <Typography
        my={2}
        fontSize={"1.5rem"}
        fontWeight={600}
        textAlign={"center"}
      >
        Welcome To Residental Jobs Dashboard!
      </Typography>

      <Grid container rowSpacing={2} mt={4}>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Username</InputLabel>
          <TextField
            autoFocus
            margin="dense"
            label="Enter your username"
            fullWidth
            variant="outlined"
            type="text"
            value={inputValues.username}
            onChange={(e) =>
              setInputValues({ ...inputValues, username: e.target.value })
            }
          />
        </Grid>
        <Grid size={12}>
          <InputLabel className={"input-label"}>Password</InputLabel>
          {/* <TextInput
            type="password"
            value={inputValues.password}
            onChange={(e) =>
              setInputValues({ ...inputValues, password: e.target.value })
            }
          /> */}
          {/* {" "} */}
          <TextField
            // autoFocus
            margin="dense"
            label="Enter your password"
            type={showCurrentPassword ? "text" : "password"}
            fullWidth
            variant="outlined"
            value={inputValues.password}
            onChange={(e) =>
              setInputValues({ ...inputValues, password: e.target.value })
            }
            // helperText="password"
            InputProps={{
              style: { backgroundColor: "#f5f5f5" },
              endAdornment: (
                <IconButton
                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                >
                  {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Stack
        my={3}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        gap={0.5}
      >
        <Link className="forgot-link" to={"/privacy-policy"}>
          Privacy Policy
        </Link>
        
        <Stack direction={"row"} alignItems={"center"} gap={0.5}>
          <Link className="forgot-link" to={"/forgot-password"}>
            Forgot Password
          </Link>
          <img src={APP_ICONS.questionIcon} width={16} />
        </Stack>
      </Stack>

      <Button
        variant="contained"
        onClick={handleLogin}
        sx={{
          mt: 1,
          height: 45,
        }}
      >
        Login
      </Button>
      <CustomSnackbar ref={snackRef} />
    </AuthContainer>
  );
};

export default LoginPage;
